import settings from "./settings.component";
import settingsUrls from "./settings.urls";
import SettingsTransforms from "./settings.transforms";

const settingsModule = angular
  .module("app.components.settings", [])
  .component("settingsPage", settings)
  .service("SettingsTransforms", SettingsTransforms)
  .config(settingsUrls);

export default settingsModule;



// WEBPACK FOOTER //
// ./src/pages/settings/settings.module.js